<template>
  <nav class="app-navbar" role="navigation" aria-label="main navigation">
    <router-link :to="logoDestination" class="app-navbar__logo">
      <img src="../../assets/logo-nav.jpg" width="50" height="28">
    </router-link>

    <div v-if="loggedIn" class="app-navbar__user">
      <router-link to="/profile" class="nav-avatar-link">
        <img v-if="userPhoto" :src="userPhoto" :alt="userInitials" class="nav-avatar nav-avatar--photo">
        <div v-else class="nav-avatar nav-avatar--initials">{{ userInitials }}</div>
      </router-link>
      <button @click="signOut" class="button is-info is-small is-rounded">
        <strong>Sign out</strong>
      </button>
    </div>
  </nav>
</template>

<script>
import { auth } from '@/firebase/firebaseInit';

export default {
  created() {
    auth.onAuthStateChanged(user => {
      this.loggedIn = !!user;
      this.userPhoto = user?.photoURL || null;
      this.userDisplayName = user?.displayName || user?.email || '';
    });
  },
  data() {
    return {
      loggedIn: false,
      userPhoto: null,
      userDisplayName: '',
    };
  },
  computed: {
    isCurrentUserAdmin() {
      return this.$store.getters['user/isCurrentUserAdmin'];
    },
    currentFD() {
      return this.$store.getters['fd/getCurrentFD'];
    },
    logoDestination() {
      if (this.isCurrentUserAdmin) return '/';
      if (this.loggedIn && this.currentFD?.status === 'LIVE') return '/';
      return '/volunteer';
    },
    userInitials() {
      if (!this.userDisplayName) return '?';
      const parts = this.userDisplayName.trim().split(' ');
      if (parts.length === 1) return parts[0][0].toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
  },
  methods: {
    async signOut() {
      try {
        this.$store.dispatch('user/setCurrentUser', null);
        await auth.signOut();
        this.$router.replace('/login');
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.app-navbar {
  display: flex;
  align-items: center;
  padding: 0 1rem;
  height: 52px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 100;
}

.app-navbar__logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.app-navbar__links {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: 1rem;
  flex: 1;
}

.app-navbar__link {
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.12s;
}

.app-navbar__link:hover,
.app-navbar__link.router-link-active {
  background: #f3f4f6;
  color: #0f172a;
}

.app-navbar__user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}

.nav-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
}

.nav-avatar--photo {
  object-fit: cover;
  border: 2px solid #e5e7eb;
}

.nav-avatar-link {
  display: flex;
  border-radius: 50%;
}

.nav-avatar-link:hover .nav-avatar {
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.4);
}

.nav-avatar--initials {
  background: #14b8a6;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
}
</style>
